export default __webpack_public_path__ + "static/media/undraw_verified_re_4io7.a1d81c24.svg";